import React, {useCallback, useContext, useState} from "react";
import {Box, Grid} from "@mui/material";
import {getCourierDropStatistics, getCourierTransactions} from "./api.js";
import {Pagination} from "../../shared/Pagination.jsx";
import {formatDate} from "../../services/utils.js";
import {Loading} from "../../shared/Loading.jsx";
import {UserContext} from "../../shared/Greet.jsx";
import {DropStatistics} from "./DropStatistics.jsx";

export const Balance = ({}) => {

  const { user } = useContext(UserContext)

  const [loading, setLoading] = useState(false)
  const [transactions, setTransactions] = useState([]);
  const [limit, setLimit] = useState(10)
  const [offset, setOffset] = useState(0)
  const [pagination, setPagination] = useState({})

  const updatePaymentsList = useCallback(({limit, offset}) => {
    if(user.user_id){
      setLoading(true)

      const promises = []

      promises.push(getCourierTransactions({userId: user.user_id, limit, offset}).then(({transactions, pagination}) => {
        setTransactions(transactions)
        setPagination(pagination)
      }))

      Promise.all(promises).then(() => {
        setLoading(false)
      })

    }
  },[user])

  return <Box component="form" sx={{ maxWidth: 600, margin: 'auto', padding: 2, bgColor: "fff" }}>
    <Grid container spacing={2}>

      <div style={{width: "100%"}}>
        <h2>Баланс</h2>

        { loading && <Loading />}

        Мой баланс: { user.balance }

        <div>
          <DropStatistics user={user} />
        </div>

        <div className="mt-5">
          <Pagination pagination={pagination} onChange={updatePaymentsList} limit={limit} offset={offset} setLimit={setLimit} setOffset={setOffset}>
            <table className="w-full border-2 border-separate p-2 border-spacing-2 border-solid">
              <thead>
              <tr>
                <td>Оператор</td>
                <td>Дата</td>
                <td>Сумма</td>
                <td>Комментарий</td>
              </tr>
              </thead>
              <tbody>
              {transactions?.map((transaction) => {
                return <tr key={transaction.id} className="border-2">
                  <td>
                    {transaction.transaction_type}
                  </td>
                  <td>
                    {formatDate(transaction.created_at)}
                  </td>
                  <td>
                    {transaction.amount}
                  </td>
                  <td>
                    {transaction.comment}
                  </td>
                </tr>
              })}
              </tbody>
            </table>
          </Pagination>

        </div>

      </div>

    </Grid>
  </Box>
}
